import React, { useState } from "react";
import { Input, Button, } from "antd";
import { httpPost, httpUrl, httpGet } from "../api/httpClient";
import { useNavigate, } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import Const from "../const";
import { loadCoinList } from "../lib/util/coinListUtil";
import "../css/pages.scss";

const Login = () => {

  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [id, setId] = useState("");
  const [otpKey, setOtpKey] = useState("")
  const [otpLogin, setOtpLogin] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const enterApp = async () => {
    try {
      await loadCoinList();
      navigate("/transaction/DepositRequestList");
    } catch (e) {
      console.error(e);
      alert("코인 목록을 불러오지 못했습니다. 다시 로그인해주세요.");
    }
  };

  const handleSubmit = () => {
    httpPost(httpUrl.login, [], {
      id: id,
      password: password,
    })
      .then(async (res) => {
        console.log("eoeoeoewowoeo")
        if (res.result && res.data.adminUser != null) {
          let listData = res.data.adminUser;
          reactLocalStorage.setObject(Const.appName + '#loginInfo', listData);
          if (listData.securityLevel > 0) {
            setOtpLogin(true);
            setDisabled(true);
            loadCoinList().catch((e) => console.error(e));
          } else {
            await enterApp();
          }
       
        } else if (res.data.reason === "INVALID_LOGIN_PASSWORD") {
          alert("비밀번호가 잘못되었습니다.");
        } else if (res.data.reason === "INVALID_LOGIN_ID") {
          alert("존재하지 않는 아이디입니다.")
        } else if (res.reason == 'EXPIRED') {
          alert("탈퇴된 아이디입니다.")
        } else {
          alert("로그인에 실패하였습니다!")
        }
      })
      .catch((e) => {
        console.log(e)
        alert("로그인에 실패하였습니다.")
      });
  }
  const checkOtp = () => {
    httpGet(httpUrl.checkOtpKey, [otpKey]).then(async (result)=>{
      console.log("## checkOtp result: " + JSON.stringify(result));
      result = result.data;              
      if(result){        
          console.log(result)
          await enterApp();
    } else {
      alert("otp번호가 다르거가 오류가 발생했습니다. 다시 시도해주세요.");                  
  }
    }).catch(e=>{
    console.log ("## userPhoneauthCheck error: " + e)
  });    
  }
  return (
    <div id="login">
      <div className="l-wrapper">
        {/* <div className="login-img">
          <img src={login} className="login" />
        </div> */}
        <div className="login-wrapper" >
          <div className="login-title" style={{ color: "#000" }}>BlockSignal</div>
          <Input
            style={{ border: 0, backgroundColor: '#f5f5f5', padding: 10, width: 400, textAlign: 'center', marginBottom: 20 }}
            placeholder="아이디를 입력해주세요"
            disabled={disabled}
            onChange={(e) => {
              setId(e.target.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSubmit()
              }
            }}
          />
          <Input
            style={{ border: 0, backgroundColor: '#f5f5f5', padding: 10, width: 400, textAlign: 'center' }}
            type="password"
            placeholder="비밀번호를 입력해주세요"
            disabled={disabled}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSubmit()
              }
            }}
          />         
          <Button
            type="primary"
            htmlType="submit"
            disabled={disabled}
            className="login-form-button"
            onClick={handleSubmit}
            style={{ backgroundColor: "#1075ff" }}
          >
            로그인
          </Button>
          {
            otpLogin && 
            <div className="loginOtp">
              <p>추가적으로 OTP 인증을 해주세요</p>
               <Input
                style={{ border: 0, backgroundColor: '#f5f5f5', padding: 10, width: 400, textAlign: 'center' }}
                placeholder="otp번호를 입력해주세요"
                onChange={(e) => {
                  setOtpKey(e.target.value);
                }}              
              />
               <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                onClick={checkOtp}
                style={{ backgroundColor: "#1075ff" }}
              >
                인증하기
              </Button>
            </div>
            
          }
        </div>
      </div>
    </div >
  );
}

export default Login;
